import { createSlice } from "@reduxjs/toolkit";

// Define initial state for access rights
const initialState = [];

// Create a slice for access rights
const accessModulesSlice = createSlice({
  name: "accessModules",
  initialState,
  reducers: {
    // Action to set access rights
    setAccessModules: (state, action) => {
      console.log("Access payload received:", action.payload);
      return action.payload;
    },
    // Action to clear access rights
    clearAccessModules: () => {
      return [];
    },
  },
});

// Export actions for use in components
export const { setAccessModules, clearAccessModules } =
  accessModulesSlice.actions;

// Export reducer to be included in the store
export default accessModulesSlice.reducer;
